module.exports = {
      id: "clapboard-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#clapboard",
      toString: function () {
        return this.url;
      }
    }